export interface Option {
  id: number
  name: string
}

export interface Field {
  key: string
  label: string
  type: 'text' | 'textarea' | 'number' | 'date' | 'department' | 'person' | 'status' | 'classification' | 'nature'
  required?: boolean
  maxlength?: number
}

export type InstrumentData = Record<string, any>

export const statuses: Option[] = [
  { id: 1, name: '正常' }, { id: 2, name: '待检定校准' },
  { id: 3, name: '待维修' }, { id: 4, name: '待维护' },
  { id: 5, name: '维修中' }, { id: 6, name: '处置中' },
  { id: 7, name: '调整中' }, { id: 8, name: '检定校准中' },
  { id: 9, name: '检定校准超期' }, { id: 10, name: '处置完成' },
  { id: 11, name: '已注销' }, { id: 13, name: '已报废' }, { id: 14, name: '停用' }
]

export const fields: Field[] = [
  { key: 'name', label: '仪器名称', type: 'text', required: true, maxlength: 255 },
  { key: 'code', label: '仪器编号', type: 'text', required: true, maxlength: 255 },
  { key: 'model', label: '型号', type: 'text', maxlength: 255 },
  { key: 'brand', label: '品牌', type: 'text', maxlength: 64 },
  { key: 'device_classification', label: '设备分类', type: 'classification' },
  { key: 'asset_nature', label: '资产性质', type: 'nature' },
  { key: 'department_id', label: '科室', type: 'department', required: true },
  { key: 'custodian_id', label: '保管人', type: 'person' },
  { key: 'status', label: '仪器状态', type: 'status' },
  { key: 'status_desc', label: '状态说明', type: 'text', maxlength: 255 },
  { key: 'deposit_address', label: '存放地点', type: 'text', maxlength: 255 },
  { key: 'unit', label: '计量单位', type: 'text', maxlength: 255 },
  { key: 'entry_date', label: '取得日期', type: 'date' },
  { key: 'buy_date', label: '购入日期', type: 'date' },
  { key: 'inspect_period', label: '检定校准周期（天）', type: 'number' },
  { key: 'next_inspect_date', label: '下次检定校准日期', type: 'date' },
  { key: 'check_period', label: '期间核查周期（天）', type: 'number' },
  { key: 'next_check_date', label: '下次期间核查日期', type: 'date' },
  { key: 'maintain_period', label: '维护保养周期（天）', type: 'number' },
  { key: 'next_maintain_date', label: '下次维护保养日期', type: 'date' },
  { key: 'extend_info', label: '备注', type: 'textarea' }
]

export function formData(source: InstrumentData = {}): InstrumentData {
  const data: InstrumentData = {}
  fields.forEach(field => {
    const value = source[field.key]
    data[field.key] = value == null
      ? (field.type === 'text' || field.type === 'textarea' ? '' : null)
      : value
  })
  if (!source.id) data.status = 1
  if (!data.custodian_id) data.custodian_id = null
  return data
}

export function fieldValue(data: InstrumentData, field: Field): string {
  if (field.type === 'department') return data.department_name || (data.department_id ? '部门已不可用' : '—')
  if (field.type === 'person') return data.custodian_name || (data.custodian_id ? '人员已不可用' : '—')
  if (field.type === 'status') return statuses.find(item => item.id === data.status)?.name || '未知'
  const value = data[field.key]
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
}
